export const SET_SCHEDULE_AMOUNT = 'SET_SCHEDULE_AMOUNT';
export const SET_SCHEDULE_FREQUENCY = 'SET_SCHEDULE_FREQUENCY';
export const SET_SCHEDULE_ADD_CASH_AMOUNT = 'SET_SCHEDULE_ADD_CASH_AMOUNT';

export const setScheduleAmount = (amount) => {
  return {
    type: SET_SCHEDULE_AMOUNT,
    amount,
  };
};

export const setScheduleFrequency = (frequency) => {
  return {
    type: SET_SCHEDULE_FREQUENCY,
    frequency,
  };
};

export const addCashAmount = (amount) => {
  return {
    type: SET_SCHEDULE_ADD_CASH_AMOUNT,
    amount,
  };
};
